import { useTranslation } from "react-i18next";
import css from './css.module.scss';
// logos
import Abinbev from 'assets/home/customers/abinbev.png';
import Bancohipotecario from 'assets/home/customers/bancohipotecario.png';
import BnpParibas from 'assets/home/customers/bnpParibas.png';
import Correoschile from 'assets/home/customers/correoschile.png';
import GrupoSura from 'assets/home/customers/grupoSura.png';
import Puma from 'assets/home/customers/puma.png';
import SancorSeguros from 'assets/home/customers/sancorSeguros.png';
import Sanofi from 'assets/home/customers/sanofi.png';
import AFPHabitat from 'assets/home/customers/afp_habitat.png';
import BancoSol from 'assets/home/customers/BancoSol.png';
import Dia from 'assets/home/customers/Dia-Logo.png';
import VePorMas from 'assets/home/customers/Logo_del_Banco_Ve_por_Más.png';
import redbelt from 'assets/home/customers/redbelt.png';

import Googleanalitics from 'assets/home/integrations/googleanalitics.png';
import Magento from 'assets/home/integrations/magento.png';
import Salesforce from 'assets/home/integrations/salesforce.png';
import Shopify from 'assets/home/integrations/shopify.png';
import Vtex from 'assets/home/integrations/vtex.png';
import Woocomerce from 'assets/home/integrations/woocommerce.png';
import Zendesk from 'assets/home/integrations/zendesk.png';
import Mailchimp from 'assets/home/integrations/mailchimp.png';

import clsx from 'clsx';
import useLanguage from "hooks/i18n";

const Community = () => {

  const [t] = useTranslation('global');
  const [language] = useLanguage();

    return (
        <div>
            <section className={css.clientes}>
                <h4>{t('home.customers')}</h4>
                <div className={css['logo-container']}>
                    <div className={css['logo-groups']}>
                        <div className={css['logo-group']}>
                            <img width='100%' height='100%' loading="lazy" src={GrupoSura} alt="GrupoSura" />
                            <img width='100%' height='100%' loading="lazy" src={Abinbev} alt="Abinbev" />
                            <img width='100%' height='100%' loading="lazy" src={SancorSeguros} alt="SancorSeguros" />
                        </div>
                        <div className={css['logo-group']}>
                            <img width='100%' height='100%' loading="lazy" src={Sanofi} alt="Sanofi" />
                            <img width='100%' height='100%' loading="lazy" src={BnpParibas} alt="BnpParibas" />
                            <img width='100%' height='100%' loading="lazy" src={Correoschile} alt="Correoschile" />
                        </div>
                    </div>
                    <div className={css['logo-groups']}>
                        <div className={css['logo-group']}>
                            <img width='100%' height='100%' loading="lazy" src={Puma} alt="Puma" />
                            <img width='100%' height='100%' loading="lazy" src={Bancohipotecario} alt="Bancohipotecario" />
                            <img width='100%' height='100%' loading="lazy" src={AFPHabitat} alt="AFPHabitat" />
                        </div>
                        <div className={css['logo-group']}>
                            <img width='100%' height='100%' loading="lazy" src={BancoSol} alt="BancoSol" />
                            <img width='100%' height='100%' loading="lazy" src={language === 'pt' ? redbelt : Dia} alt={language === 'pt' ? 'redbelt' : "Dia"} />
                            <img width='100%' height='100%' loading="lazy" src={VePorMas} alt="VePorMas" />
                        </div>
                    </div>
                </div>
            </section>
            <section className={css.integrations}>
                <h4>{t('home.integrations')}</h4>
                <div className={clsx(css['logo-container'], css['integrations-images'])}>
                    <img width='100%' height='100%' loading="lazy" src={Googleanalitics} alt="Googleanalitics" />
                    <img width='100%' height='100%' loading="lazy" src={Vtex} alt="Vtex" />
                    <img width='100%' height='100%' loading="lazy" src={Salesforce} alt="Salesforce" />
                    <img width='100%' height='100%' loading="lazy" src={Magento} alt="Magento" />
                    <img width='100%' height='100%' loading="lazy" src={Woocomerce} alt="Woocomerce" />
                    <img width='100%' height='100%' loading="lazy" src={Shopify} alt="Shopify" />
                    <img width='100%' height='100%' loading="lazy" src={Zendesk} alt="Zendesk" />
                    <img width='100%' height='100%' loading="lazy" src={Mailchimp} alt="Mailchimp" />
                </div>
            </section>
        </div>
    );
}

export default Community;